<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_check="false"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>메인 화면</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'

export default {
  name: 'AdminMain',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Main/AdminMain.vue